// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"filter-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 8C16.6944 8 20.5 6.88071 20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5C3.5 6.88071 7.30558 8 12 8Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5C3.5 4.11929 7.30558 3 12 3C16.6944 3 20.5 4.11929 20.5 5.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5M20.5 5.5C20.5 4.11929 16.6944 3 12 3C7.30558 3 3.5 4.11929 3.5 5.5M20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5","strokeWidth":"props.strokeWidth"}}]}]};

const Filter1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-1',
    ref,
    icon: element,
  },
));

Filter1Icon.displayName = 'Filter1Icon';

export default Filter1Icon;
